import { QUALITY_TIMELINE_AXIS } from '../../consts';

type LocaleDateTimeOptions = Intl.DateTimeFormatOptions;

function withTimeZone(
  options: LocaleDateTimeOptions,
  timeZone: string | undefined,
): LocaleDateTimeOptions {
  return timeZone ? { ...options, timeZone } : options;
}

/**
 * Picks a tick label string from day-only down to hour-minute-second based on how many hours fit in the visible window.
 * Uses `locale` for `Date` formatting (same BCP 47 tag as the app's IntlProvider).
 * Optional `timeZone` (IANA) formats wall clock in that zone for the same instants.
 */
export function formatTimelineAxisTick(
  locale: string,
  visibleHours: number,
  tickValue: Date | number,
  timeZone?: string,
): string {
  const date = new Date(tickValue.valueOf());

  if (visibleHours > QUALITY_TIMELINE_AXIS.tickVisibleHoursDayFocus) {
    return date.toLocaleDateString(
      locale,
      withTimeZone(
        {
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
        },
        timeZone,
      ),
    );
  }

  if (visibleHours > QUALITY_TIMELINE_AXIS.tickVisibleHoursDateTime) {
    return date.toLocaleString(
      locale,
      withTimeZone(
        {
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          hour12: false,
        },
        timeZone,
      ),
    );
  }

  if (visibleHours > QUALITY_TIMELINE_AXIS.tickVisibleHoursHmOnly) {
    return date.toLocaleTimeString(
      locale,
      withTimeZone(
        {
          hour: '2-digit',
          minute: '2-digit',
          hour12: false,
        },
        timeZone,
      ),
    );
  }

  return date.toLocaleTimeString(
    locale,
    withTimeZone(
      {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
      },
      timeZone,
    ),
  );
}
